import React, { useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiActivity, FiEye, FiThumbsDown, FiThumbsUp } from "react-icons/fi";

import Button, { Color } from "../../../../../components/Form/Button";
import { StyledMenu } from "../../../../../components/Generic/AnchorMenu";
import { MOBILE_MAX_SIZE } from "../../../../../constants";
import useStyles, { ActionMenuItem, SendReviewButton, ViewActivityButton, ButtonsWrapperWhenIsMobile } from "./styled";

export type LoadingType = {
  approve: boolean;
  decline: boolean;
  review: boolean;
}

interface ActionButtonsProps {
  loadings?: LoadingType;
  onOpenActivityScreen?: () => void;
  onSend: (modalType: "success"|"warning"|"error") => void;
}

export const ActionButtons = (props: ActionButtonsProps) => {
  const { loadings, onOpenActivityScreen, onSend } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const isMobile = window.innerWidth <= MOBILE_MAX_SIZE;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return isMobile ? (
    <ButtonsWrapperWhenIsMobile>
      {onOpenActivityScreen && (
        <ViewActivityButton
          startIcon={<FiActivity />}
          onClick={onOpenActivityScreen}
        >
          {translate("viewActivity")}
        </ViewActivityButton>
      )}
      <StyledMenu
        id="extra-actions-menu"
        anchorEl={anchorEl}
        keepMounted={false}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        disableAutoFocusItem
        PaperProps={{
          style: {
            transform: "translate(-9px, -135px)",
          },
        }}
      >
        <ActionMenuItem
          data-cy="user-action-change-status"
          onClick={() => {
            setAnchorEl(null);
            onSend("success")
          }}
          type="approve"
        >
          <FiThumbsUp />
          {translate("approve")}
        </ActionMenuItem>

        <ActionMenuItem
          onClick={() => {
            setAnchorEl(null);
            onSend("error")
          }}
          type="decline"
        >
          <FiThumbsDown />
          {translate("decline")}
        </ActionMenuItem>

        <ActionMenuItem
          onClick={() => {
            setAnchorEl(null);
            onSend("warning")
          }}
          type="sendToReview"
        >
          <FiEye />
          {translate("sendToReview")}
        </ActionMenuItem>
      </StyledMenu>
      <Button
        customColor={Color.SECONDARY}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {translate("actions")}
      </Button>
    </ButtonsWrapperWhenIsMobile>
  ) : (
    <Grid container direction="row" alignItems="center" justifyContent="space-between" className={classes.mt40}>
      <Grid item xs>
        <SendReviewButton
          customColor={Color.INFO}
          onClick={() => {
            onSend("warning");
          }}
          loading={loadings?.review}
          disabled={loadings?.decline || loadings?.approve}
        >{translate("sendToReview")}</SendReviewButton>
      </Grid>
      <Grid item container direction="row" spacing={2} xs justifyContent="flex-end">
        <Grid item>
          <Button
            customColor={Color.ERROR}
            onClick={() => {
              onSend("error");
            }}
            loading={loadings?.decline}
            disabled={loadings?.approve || loadings?.review}
          >{translate("decline")}</Button>
        </Grid>
        <Grid item>
          <Button
            customColor={Color.SUCCESS}
            loading={loadings?.approve}
            disabled={loadings?.decline || loadings?.review}
            onClick={() => {
              onSend("success");
            }}
          >{translate("approve")}</Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
